import { useMemo } from 'react';
import { ENV, EnvironmentConfig } from '../config/environment';

export const useEnvironment = (): EnvironmentConfig => {
  return useMemo(() => ENV, []);
};

export const useIsProduction = (): boolean => {
  const env = useEnvironment();
  return env.ENVIRONMENT_TYPE === 'production';
};

export const useIsDevelopment = (): boolean => {
  const env = useEnvironment();
  return env.ENVIRONMENT_TYPE === 'development';
};